/**
 * Route for `multiple-landing-pages-per-offer`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MultipleLandingPagesPerOfferPage } from "../features/multiple-landing-pages-per-offer/MultipleLandingPagesPerOfferPage";

export const multipleLandingPagesPerOfferRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/multiple-landing-pages-per-offer",
	component: MultipleLandingPagesPerOfferPage,
});

export default multipleLandingPagesPerOfferRoute;
